import React from 'react';
import { Container, Grid, Typography, Card, CardContent, CardMedia, Rating } from '@mui/material';
import reactpic from '../assets/react-basics.jpg';
import fireb from '../assets/advanced-firebase.jpg';
import jscrpt from '../assets/mongodb.png';

const courses = [
  { title: 'React for Beginners', rating: 4.5, img: reactpic },
  { title: 'Mastering Firebase', rating: 4.7, img: fireb },
  { title: 'MongoDB: Zero-To-Hero', rating: 4, img: jscrpt },
];

const CoursesSection = () => {
  return (
    <Container sx={{ py: 8 }}>
      <Typography variant="h4" gutterBottom>
        Popular Courses
      </Typography>
      <Grid container spacing={4}>
        {courses.map((course, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card>
              <CardMedia component="img" height="140" image={course.img} alt={course.title} />
              <CardContent>
                <Typography variant="h5" component="div">
                  {course.title}
                </Typography>
                <Rating value={course.rating} readOnly />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default CoursesSection;